import { UseQuerySubscription } from '@reduxjs/toolkit/dist/query/react/buildHooks';
import { CommanderAPI } from '../CommanderAPI';
import _ from 'lodash';
import orComparator from '../../../../shared/util/lodash/merge/orComparator';
import { useMemo } from 'react';
import { isNotNullOrUndefined } from '../../../../shared/util/collection/isNotNullOrUndefined';
import useCommanderIdsByWorkspace from '../../../../redux/workspace/hooks/useCommanderIdsByWorkspace';
import { M_SECONDS_POOLING_INTERVAL_DATA } from '../../../store/Store.constants';

type Options = Parameters<UseQuerySubscription<any>>[1];

function useDeviceStatusFromWorkspace(
  workspaceId: string,
  options: Options = {}
) {
  const {
    commanders: commanderIdsDevices,
    isLoading: isLoadingCommanders,
    error: errorCommanders,
  } = useCommanderIdsByWorkspace(workspaceId);

  const skip = !commanderIdsDevices?.length || options.skip;
  const { data: devicesStatus, ...restDeviceStatus } =
    CommanderAPI.useGetDevicesStatusQuery(commanderIdsDevices ?? [], {
      ...options,
      pollingInterval: M_SECONDS_POOLING_INTERVAL_DATA,
      skip,
    });

  const fallingCommandersIds = useMemo(
    () =>
      devicesStatus &&
      commanderIdsDevices &&
      _.uniq(commanderIdsDevices)
        .map((encodedCommanderId) =>
          devicesStatus.entities[encodedCommanderId]?.mqttConnected === false
            ? encodedCommanderId
            : undefined
        )
        .filter(isNotNullOrUndefined),

    [devicesStatus, commanderIdsDevices]
  );

  return {
    ..._.mergeWith(
      { isLoading: isLoadingCommanders, error: errorCommanders },
      restDeviceStatus,
      orComparator
    ),
    data: devicesStatus,
    restDeviceStatus: restDeviceStatus,
    numberFailingMqttConnection: fallingCommandersIds?.length,
    commanderIdsDevices,
  };
}

export default useDeviceStatusFromWorkspace;
